module.exports = __webpack_public_path__ + "videos/straight-jacket-escape.aca3b65.mp4";